import { useContext } from "react"
import type { CountrySelectionContextValue } from "./CountrySelectionContext"
import { CountrySelectionContext } from "./CountrySelectionContext"

export function useCountrySelectionContext(): CountrySelectionContextValue {
  const context = useContext(CountrySelectionContext)
  if (!context) {
    throw new Error("elements using useCountrySelcetionContext must be wrapped in <CountrySelectionContextProvider>")
  }

  return context
}
